import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import commonEn from "./en/commonEn";
import dashboardEn from "./en/dashboardEn";
import masterEn from "./en/masterEn";
import settingsEn from "./en/settings";
import usersEn from "./en/users";
import companyEn from "./en/companyEn";
import onlineClassEn from "./en/onlineClassEn";
import assignEn from "./en/assignEn";
import assignmentEn from "./en/assignmentEn";
import paperGenerationEn from "./en/paperGenerationEn";
import classEn from "./en/classEn";
import dayEn from "./en/dayEn";
import registrationEn from "./en/registrationEn";
import paymentHistoryEn from "./en/paymentHistoryEn";

const resources = {
    en: {
        translation: {
            ...commonEn,
            ...dashboardEn,
            ...masterEn,
            ...settingsEn,
            ...usersEn,
            ...companyEn,
            ...onlineClassEn,
            ...assignEn,
            ...assignmentEn,
            ...paperGenerationEn,
            ...classEn,
            ...dayEn,
            ...registrationEn,
            ...paymentHistoryEn,
        }
    },
};

// Initialize i18next
i18n.use(initReactI18next).init({
    resources,
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: { escapeValue: false }
});

export default i18n;
